import { computed, inject, Injectable, signal } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Observable } from 'rxjs';
import { BaseApiService } from '@infrastructure/api/base';
import { environment } from '../../../src/environment/environment';

export interface Variant {
  id: string;
  title: string;
  image_url: string;
  price_in_stars: number;
  border_color?: string;
}

export interface GiftEvent extends Variant {
  _eventId: string; // Unique event identifier for tracking
}

@Injectable({
  providedIn: 'root',
})
export class GiftFeedService {
  private socket$: WebSocketSubject<any>;
  readonly #baseApi = inject(BaseApiService);

  readonly #gifts = signal<GiftEvent[]>([]);

  public readonly giftsVm = computed<{ list: GiftEvent[] }>(() => {
    return {
      list: this.#gifts(),
    };
  });

  public addGift(gift: Variant): void {
    // Add unique event ID for proper tracking
    const giftWithEventId: GiftEvent = {
      ...gift,
      _eventId: `${gift.id}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    };
    this.#gifts.update(gifts => {
      const newGifts = [giftWithEventId, ...gifts];
      // Limit to 100 items for performance
      return newGifts.slice(0, 100);
    });
  }

  constructor() {
    this.socket$ = webSocket(`${environment.WS_URL}/ws/gift-feed`);
  }

  messages$(): Observable<any> {
    return this.socket$.asObservable();
  }

  send(msg: any): void {
    this.socket$.next(msg);
  }

  close(): void {
    this.socket$.complete();
  }

  public getHistory(): Observable<any> {
    return this.#baseApi.get('/gift-feed/history');
  }
}
